import { createSlice } from "@reduxjs/toolkit";
import type { ReportsActionTypes, ReportsState } from "../types/reportsState.types";
import { REPORTS_SLICE_NAME } from "../utils/storeUtils";

const initialState: ReportsState = {
  reports: [],
};

export const reportsSlice = createSlice({
  name: REPORTS_SLICE_NAME,
  initialState,
  reducers: {
    setReports: (state, action: ReportsActionTypes["setReports"]) => {
      state.reports = action.payload;
    },
  },
});

export default reportsSlice.reducer;
